import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=4eb57427&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=4eb57427&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb57427",
  null
  
)

export default component.exports